import React, { FC, useCallback, useMemo } from 'react';
import { Row, Col, Card, Tooltip, List } from 'antd';
import { withRouter } from 'react-router';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import Mapbox from '../mapbox/Mapbox';
import { OperatingHoursCardDisplay } from '../operating_hours_card_display/OperatingHoursCardDisplay';
import { connect } from 'react-redux';
import OWEditableNotesComponent from '../common/OWEditableNotesComponent';
import LocationContactInformation from '../locations_detail_details_page/LocationContactInformation';
import { contractorLocationsRestCrudThunksForSupplier } from '../../thunks/contractor_locations_thunks';
import FileUploader from '../file_uploader/FileUploader';

require('../supplier_location_page_display/SupplierLocationPageDisplay.less');

const ContractorLocationPageDisplay: FC<any> = ({
	record,
	locationsFetching,
	updateLocation,
	currentUser,
	isDetailPage,
}): React.ReactElement => {
	const locationId = useMemo(() => record.id, [record.id]);

	const handleSaveLocationNotes = useCallback(
		(propName) => (notes) => {
			const updatedLocation = {
				...record,
				[propName]: notes,
			};
			return updateLocation(updatedLocation);
		},
		[record, updateLocation]
	);

	const canModifyLocation = useMemo(
		() =>
			nullSafeGet('supplierFacilityId', record) &&
			nullSafeGet('supplierFacilityId', record) === nullSafeGet('facility.id', currentUser),
		[currentUser, record]
	);

	const handleInternalFileAttachmentUploadChange = useCallback(
		(internalAttachments) => {
			const updatedLocation = {
				...record,
				internalAttachments: internalAttachments,
			};
			updateLocation(updatedLocation);
		},
		[record, updateLocation]
	);

	console.log(currentUser);
	console.log(record);

	const canSeeInternalNotesAndAttachments = useMemo(
		() =>
			nullSafeGet('facility.id', currentUser) &&
			nullSafeGet('facility.id', currentUser) === record.supplierFacilityId,
		[currentUser, record.supplierFacilityId]
	);

	return locationsFetching ? (
		<PageLoadingPlaceholder />
	) : (
		<Row style={{ margin: '16px 4px' }} gutter={12} key={record.id}>
			<Col span={16}>
				<div className="rowSpacing">
					<Card className="materialCard" bodyStyle={{ padding: 0 }}>
						<div style={{ height: 300, position: 'absolute', top: 0, left: 0, right: 0 }}>
							<Mapbox
								longitude={nullSafeGet('longitude', record)}
								latitude={nullSafeGet('latitude', record)}
								baseLayerStyle="light"
								zoomLevel={7}
							/>
						</div>
						<div style={{ height: 300, position: 'relative' }} />
						<div className="px-6 py-4">
							<div className="materialCard__title">
								{nullSafeGet('primaryAddress.streetAddress1', record)}
							</div>
							{nullSafeGet('primaryAddress.streetAddress2', record) ? (
								<div className="materialCard__title">
									{nullSafeGet('primaryAddress.streetAddress2', record)}
								</div>
							) : null}
							<div className="materialCard__subtitle">
								{nullSafeGet('primaryAddress.city', record)},{' '}
								{nullSafeGet('primaryAddress.region', record)}{' '}
								{nullSafeGet('primaryAddress.postcode', record)}
							</div>
						</div>
					</Card>
				</div>
				{/* <div className="rowSpacing">
					<LocationActiveWorkOrders locationId={locationId} showActions={false} />
				</div>
				<div className="rowSpacing">
					<LocationWorkHistory locationId={locationId} showActions={false} />
				</div> */}
			</Col>
			<Col span={8}>
				{canSeeInternalNotesAndAttachments && isDetailPage ? (
					<div className="rowSpacing">
						<Card title={`Client${nullSafeGet('contractorClients.1', record) ? 's' : ''}`}>
							<List
								dataSource={nullSafeGetOrElse('contractorClients', record, [])}
								renderItem={(item: any) => <List.Item>{item.name}</List.Item>}
							/>
						</Card>
					</div>
				) : null}
				{canSeeInternalNotesAndAttachments ? (
					<>
						<div className="rowSpacing">
							<OWEditableNotesComponent
								id="buyerNotes"
								tooltipMessage="Only visible to your team"
								title="Internal Notes"
								notes={nullSafeGet('internalNotes', record)}
								allowEdit={canModifyLocation}
								onSaveNotes={handleSaveLocationNotes('internalNotes')}
							/>
						</div>

						<div className="rowSpacing">
							<Tooltip placement="top" title="Only visible to your team">
								<Card title="Internal Attachments">
									<FileUploader
										roleType="supplier"
										defaultFileList={nullSafeGetOrElse('internalAttachments', record, [])}
										handleUploadSuccess={handleInternalFileAttachmentUploadChange}
										uploaderType={canModifyLocation ? 'dragger' : 'readOnly'}
									/>
								</Card>
							</Tooltip>
						</div>
					</>
				) : null}
				<div className="rowSpacing">
					<OWEditableNotesComponent
						id="notes"
						tooltipMessage="visible to everyone"
						title="Shared Notes"
						allowEdit={canModifyLocation}
						notes={nullSafeGetOrElse('notes', record, '')}
						onSaveNotes={handleSaveLocationNotes('notes')}
					/>
				</div>
				<LocationContactInformation location={record} />
				<div className="rowSpacing">
					<OperatingHoursCardDisplay operatingHours={record.operatingHours} />
				</div>
			</Col>
		</Row>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	getLocation: (id) => dispatch(contractorLocationsRestCrudThunksForSupplier.readOne(id)),
	updateLocation: (entity) => dispatch(contractorLocationsRestCrudThunksForSupplier.update(entity)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(ContractorLocationPageDisplay)
);
